export const checkErrorFn = async (response) => {
  if (!response.ok) {
    const error = new Error('An error occurred while fetching the data.')
    let error_info = ''
    try {
      error_info = await response.json()
    } catch (error) {
      console.error('Error parsing response', error)
    }
    error.response = response
    error.info = error_info
    error.status = response.status
    return error
  }
  return null
}
